// eslint-disable-next-line no-restricted-imports
import { useDispatch } from 'react-redux';

import { AppDispatch } from 'bootstrap.store';

/** Represents a typed dispatch hook. */
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
